// Formato de montos y fechas del módulo Punto V. Solo presentación: los
// montos llegan calculados del backend.

const usd = new Intl.NumberFormat('es-VE', { style: 'currency', currency: 'USD' });

export const fmtUsd = (v) => (v === null || v === undefined || v === '' ? '—' : usd.format(Number(v)));

// Fechas puras: se parsea el texto para no correr un día por la zona horaria.
export const fmtFecha = (f) => {
  if (!f) return '—';
  const [y, m, d] = String(f).slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

export const fmtPct = (v) => (v === null || v === undefined ? '—' : `${Number(v).toLocaleString('es-VE', { maximumFractionDigits: 2 })} %`);
export const fmtEntero = (v) => Number(v || 0).toLocaleString('es-VE');
export const fmtDiaCorto = (d) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;

// Fecha local en AAAA-MM-DD (sin pasar por UTC).
export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Solo presentación: los días sin ventas aparecen en 0 para que el eje de
// tiempo sea continuo. Los montos vienen calculados del backend.
export const diasCompletos = (porDia, desde, hasta) => {
  const porFecha = new Map(porDia.map(d => [d.dia, d]));
  const salida = [];
  const [y1, m1, d1] = desde.split('-').map(Number);
  const [y2, m2, d2] = hasta.split('-').map(Number);
  for (let f = new Date(y1, m1 - 1, d1); f <= new Date(y2, m2 - 1, d2); f.setDate(f.getDate() + 1)) {
    const clave = iso(f);
    salida.push(porFecha.get(clave) || { dia: clave, venta: 0, ganancia: 0, n_ventas: 0, margen_pct: null });
  }
  return salida;
};

// Solo presentación: las 24 horas del día, con 0 en las que no hubo ventas.
export const horasCompletas = (porHora) => {
  const porNumero = new Map((porHora || []).map(h => [h.hora, h]));
  return Array.from({ length: 24 }, (_, hora) => porNumero.get(hora) || { hora, venta: 0, ganancia: 0, n_ventas: 0, margen_pct: null });
};
export const fmtHora = (h) => `${String(h).padStart(2, '0')}h`;
export const fmtRangoHora = (h) => `${String(h).padStart(2, '0')}:00 – ${String(h).padStart(2, '0')}:59`;

// Laravel manda 'AAAA-MM-DD HH:MM:SS' sin zona (Safari no lo parsea con el
// espacio): se toma como hora de Caracas (UTC-4, sin horario de verano).
export const fmtFechaHora = (f) => {
  if (!f) return '—';
  const texto = String(f).replace(' ', 'T');
  const fecha = new Date(/T\d{2}:\d{2}(:\d{2})?$/.test(texto) ? `${texto}-04:00` : texto);
  return Number.isNaN(fecha.getTime()) ? '—' : fecha.toLocaleString('es-VE', { dateStyle: 'short', timeStyle: 'short' });
};

export const fmtPeriodo = (p) => {
  if (!p) return '—';
  const [y, m] = p.split('-');
  const nombre = new Date(Number(y), Number(m) - 1, 1).toLocaleDateString('es-VE', { month: 'long' });
  return `${nombre.charAt(0).toUpperCase()}${nombre.slice(1)} ${y}`;
};

export const periodoActual = () => {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
};

// Plazo de entrega de una factura solicitada (la fecha límite la fija Punto V).
export const textoPlazoFactura = (s) => {
  if (s.situacion === 'enviada' || s.factura_situacion === 'enviada') return 'Enviada';
  const dias = Number(s.dias_restantes);
  if (dias > 1) return `Quedan ${dias} días`;
  if (dias === 1) return 'Vence mañana';
  if (dias === 0) return 'Vence hoy';
  return dias === -1 ? 'Vencida hace 1 día' : `Vencida hace ${-dias} días`;
};
